import { useState } from "react";
import ModalComponent from "../../../Components/Modais";
import { IComponentModal } from "../../../Components/Modais/IModalComponent";
import useAsyncEffect from "../../../hooks/useAsyncEffect";
import AtendimentoDoUsuarioDashboard from "./AtendimentoDoUsuarioDashboard";
import UsuariosAtendimentos from "./UsuariosAtendimentos";
import UsuariosOnline from "./UsuariosOnline";
import { GetBuscarAtualizacaoController } from "../../../Controllers/Sprint/SprintController";
import { useUserInfor } from "../../../Context/User";
import UltimasAtualizacao from "./UltimasAtualizacao";
import { faFileAlt } from "@fortawesome/free-solid-svg-icons";
import OrSpinner from "../../../Components/Utils/OrSpinner";
import StatusUAU from "./StatusUAU";

export default function Dashboard() {
    const [show, setShow] = useState(false);
    const [modal, setModal] = useState<IComponentModal>();
    const { ID_USUARIO } = useUserInfor().UserInfor;
    const { loading: lstAtualizacaoLoading } = useAsyncEffect(async () => {
        await GetBuscarAtualizacaoController(ID_USUARIO ?? 0).then((res) => {
            if (res) {
                setModal({
                    headerComponent: "Últimas Atualizações",
                    IconHeader: faFileAlt,
                    Component: () => (
                        <UltimasAtualizacao
                            setShow={setShow}
                            lstAtualizacao={res}
                            idUsuario={ID_USUARIO ?? 0}
                            lstAtualizacaoLoading={lstAtualizacaoLoading}
                        />
                    ),
                    size: "lg",
                });
                setShow(true);
            }
        });
    }, []);
    return (
        <div
            className="subheader py-2 py-lg-6 subheader-transparent"
            id="kt_subheader"
        >
            <div className="container-fluid d-flex flex-wrap row m-0">
                <div className="col-12 col-md-6 col-lg-4 mb-5">
                    <UsuariosOnline />
                </div>
                <div className="col-12 col-md-6 col-lg-4 mb-5">
                    <AtendimentoDoUsuarioDashboard />
                </div>
                <div className="col-12 col-lg-4 mb-5">
                    <UsuariosAtendimentos />
                </div>
                <div className="col-12 col-lg-4 mb-5">
                    <StatusUAU />
                </div>
            </div>
            <OrSpinner loading={lstAtualizacaoLoading} spinner="default">
                <ModalComponent
                    show={show}
                    setShow={setShow}
                    ModalComponent={modal}
                />
            </OrSpinner>
        </div>
    );
}
